import type { PluginTypePluginParams } from '../params/PluginTypeParams.ts';

type GetPluginRootProps = PluginTypePluginParams;

type GetPluginRootPropsSuccessResult = {
  success: true;
  props: GetPluginRootProps;
};

type GetPluginRootPropsErrorResult = {
  success: false;
  error: string;
};

export type GetPluginRootPropsResult =
  | GetPluginRootPropsSuccessResult
  | GetPluginRootPropsErrorResult;

export const getPluginRootProps = (
  params: PluginTypePluginParams,
): GetPluginRootPropsResult => {
  return { success: true, props: params };
};
